import { KnownResendNotificationChannel } from '@groundfloor-platform/mgmt-service-g-sdk';
import { DialogActions, DialogContent, MenuItem, TextField } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { parseErrorMessage } from '../../../../core/api/api.context';
import { Modal } from '../../pure/modal/modal.component';
import { TextButton } from '../../pure/text-button/text-button.component';
import { ResendNotificationActionProps, useResendNotification } from './resend-notification.hook';

export function ResendNotificationModal(props: ResendNotificationActionProps) {
  const hook = useResendNotification(props);

  return <ResendNotificationModalComponent {...hook} />;
}

export function ResendNotificationModalComponent({
  state,
  handlers,
  channelOptions
}: ReturnType<typeof useResendNotification>) {
  return (
    <Modal open title="Resend notification" loading={state.isLoading} maxWidth="xs" onClose={handlers.onCancel}>
      <DialogContent>
        {state.error && (
          <Alert variant="outlined" severity="error" style={{ marginBottom: '16px' }}>
            <AlertTitle>Something went wrong</AlertTitle>
            Error {state.error.statusCode}: {parseErrorMessage(state.error.message)}
          </Alert>
        )}
        <p>How should we send it?</p>
        <TextField
          variant="outlined"
          select
          value={state.selectedChannel}
          onChange={(e) =>
            handlers.onSelectChannel(
              e.target.value as KnownResendNotificationChannel.Email | KnownResendNotificationChannel.Sms
            )
          }
          style={{ minWidth: '220px' }}
          size="small"
        >
          {channelOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <TextButton color="secondary" variant="outlined" onClick={handlers.onCancel}>
          Cancel
        </TextButton>
        <TextButton color="primary" variant="outlined" onClick={handlers.onSendNotification}>
          Send
        </TextButton>
      </DialogActions>
    </Modal>
  );
}
